module.exports = __webpack_public_path__ + "img/caselist2.6ba99b53.jpg";